<ion-row class="ion-justify-content-center ion-align-items-start" [class.stretched]="node?.stretched"
  [class.withBackground]="node?.withBackground">
  <ion-col size="12">
    <div class="img-wrapper">
      <app-img-format *ngIf="node?.url" [src]="node?.url" [alt]="node?.alt" [aspectRatio]="node?.ratio"
        [disableLazyLoad]="true"></app-img-format>

      <!-- SPONSOR -->
      <app-sponsor-overlay *ngIf="sponsor" [sponsor]="sponsor"></app-sponsor-overlay>
    </div>
  </ion-col>
</ion-row>